import ReactPlayer from 'react-player';

type VideoPlayerProps = {
  url: string;
};

export const VideoPlayer = ({ url }: VideoPlayerProps) => {
  return (
    <div className='aspect-video w-full'>
      <ReactPlayer
        controls
        url={url}
        config={{
          file: {
            attributes: {
              crossOrigin: 'use-credentials',
            },
            hlsOptions: {
              forceHLS: true,
              xhrSetup: function (xhr: XMLHttpRequest) {
                xhr.withCredentials = true;
              },
            },
          },
        }}
        width='100%'
        height='100%'
        playsinline
      />
    </div>
  );
};
